export default "__VITE_ASSET__c64f368c__"